import { render, staticRenderFns } from "./BulkUnsubscriptionList.vue?vue&type=template&id=65bf98b3&scoped=true&"
import script from "./BulkUnsubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./BulkUnsubscriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./BulkUnsubscriptionList.vue?vue&type=style&index=0&id=65bf98b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf98b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
